import { render, staticRenderFns } from "./billAddressDialog.vue?vue&type=template&id=1a954390&"
import script from "./billAddressDialog.vue?vue&type=script&lang=js&"
export * from "./billAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./billAddressDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a954390')) {
      api.createRecord('1a954390', component.options)
    } else {
      api.reload('1a954390', component.options)
    }
    module.hot.accept("./billAddressDialog.vue?vue&type=template&id=1a954390&", function () {
      api.rerender('1a954390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/billAddressDialog.vue"
export default component.exports